import * as angular from 'angular';
class PricingCtrl {
    [x: string]: any;
 	 static $inject = ['IntlTelInput','$anchorScroll','Pricing'];
    constructor(IntlTelInput, $anchorScroll, Pricing) {
        this.countries = angular.copy(IntlTelInput.getCountryData());
        this.anchorScroll = $anchorScroll;
        this.Pricing = Pricing;
    }

    $onInit() {
        this.Pricing.countries({}, (data) => {
            this.countryList = data;
            this.countries = this.countries.filter((element => {
                return this.countryList.includes(element.iso2.toUpperCase())
            })).map((element) => {
                element.dialCode = '+' + element.dialCode;
                return element;
            });
        });
        this.anchorScroll();

    }

    search(searchText) {
        this.find = searchText;
    }
}
export default {
    controller: PricingCtrl,
    template: require("./pricing.html")
};
